import React from 'react';
import Icon from 'components/AppIcon';

const UrgentTasks = () => {
  const urgentTasks = [
    {
      id: 1,
      title: "File Appeal Documents",
      case: "Kamau vs. Njoroge",
      deadline: "Today, 17:00",
      priority: "critical",
      assignee: "Sarah Wanjiku",
      progress: 75,
      daysLeft: 0
    },
    {
      id: 2,
      title: "Submit Court Filing",
      case: "ABC Corporation Tax Appeal",
      deadline: "Tomorrow, 12:00",
      priority: "high",
      assignee: "John Kamau",
      progress: 45,
      daysLeft: 1
    },
    {
      id: 3,
      title: "Client Contract Review",
      case: "Safaricom Ltd Partnership",
      deadline: "25/12/2024, 09:00",
      priority: "high",
      assignee: "Mary Wanjiku",
      progress: 20,
      daysLeft: 2
    },
    {
      id: 4,
      title: "Prepare Witness Statements",
      case: "Mwangi Property Dispute",
      deadline: "26/12/2024, 14:00",
      priority: "medium",
      assignee: "Peter Kimani",
      progress: 60,
      daysLeft: 3
    },
    {
      id: 5,
      title: "Draft Settlement Agreement",
      case: "Njoroge Divorce Proceedings",
      deadline: "27/12/2024, 16:00",
      priority: "medium",
      assignee: "Sarah Wanjiku",
      progress: 30,
      daysLeft: 4
    }
  ];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'critical': return 'text-accent bg-accent-50 border-accent';
      case 'high': return 'text-warning-600 bg-warning-50 border-warning-500';
      case 'medium': return 'text-secondary-600 bg-secondary-50 border-secondary-300';
      default: return 'text-text-secondary bg-secondary-50 border-secondary-300';
    }
  };

  const getProgressColor = (progress, priority) => {
    if (priority === 'critical') return 'bg-accent';
    if (priority === 'high') return 'bg-warning-500';
    return 'bg-primary';
  };

  const getDaysLeftColor = (daysLeft) => {
    if (daysLeft === 0) return 'text-accent';
    if (daysLeft <= 1) return 'text-warning-600';
    return 'text-text-secondary';
  };

  return (
    <div className="bg-surface rounded-lg shadow-card border border-border">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-heading font-semibold text-text-primary">Urgent Tasks</h2>
          <button className="text-primary hover:text-primary-700 transition-smooth">
            <Icon name="Plus" size={20} />
          </button>
        </div>
        <p className="text-sm text-text-secondary mt-1">Approaching deadlines require attention</p>
      </div>

      <div className="p-6">
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {urgentTasks.map((task) => (
            <div key={task.id} className="border border-border rounded-lg p-4 hover:shadow-card transition-smooth">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <h3 className="text-sm font-medium text-text-primary">{task.title}</h3>
                    <span className={`text-xs px-2 py-1 rounded-full border ${getPriorityColor(task.priority)}`}>
                      {task.priority}
                    </span>
                  </div>
                  <p className="text-xs text-text-secondary mb-2">{task.case}</p>
                  <div className="flex items-center space-x-4 text-xs text-text-secondary">
                    <div className="flex items-center space-x-1">
                      <Icon name="User" size={12} />
                      <span>{task.assignee}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <Icon name="Clock" size={12} />
                      <span className={getDaysLeftColor(task.daysLeft)}>
                        {task.daysLeft === 0 ? 'Due Today' : `${task.daysLeft} days left`}
                      </span>
                    </div>
                  </div>
                </div>
                <button className="text-text-secondary hover:text-text-primary transition-smooth">
                  <Icon name="MoreVertical" size={16} />
                </button>
              </div>

              <div className="mb-3">
                <div className="flex items-center justify-between text-xs text-text-secondary mb-1">
                  <span>Progress</span>
                  <span>{task.progress}%</span>
                </div>
                <div className="w-full bg-secondary-200 rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full transition-smooth ${getProgressColor(task.progress, task.priority)}`}
                    style={{ width: `${task.progress}%` }}
                  ></div>
                </div>
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-1 text-xs text-text-secondary">
                  <Icon name="Calendar" size={12} />
                  <span>Due: {task.deadline}</span>
                </div>
                <div className="flex items-center space-x-2">
                  <button className="text-primary hover:text-primary-700 transition-smooth">
                    <Icon name="Play" size={14} />
                  </button>
                  <button className="text-success hover:text-success-700 transition-smooth">
                    <Icon name="Check" size={14} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <button className="w-full mt-4 py-2 text-sm text-primary hover:text-primary-700 font-medium transition-smooth">
          View All Tasks
        </button>
      </div>
    </div>
  );
};

export default UrgentTasks;